import PC from './pc';
import H5 from './h5';
import Pad from './ipad';

export interface Props extends React.HTMLAttributes<HTMLDivElement> {}

export default isMobile ? H5 : isPad ? Pad : PC;
